import { gql, useQuery } from '@apollo/client';
import { useRouter } from 'next/router';
import * as React from 'react';

import { Loading } from '@/imports/ui/chakra/components/Loading';

import {
  BlogPage_GetPostByBlogId,
  BlogPage_GetPostByBlogIdVariables,
} from './graphql-types/BlogPage_GetPostByBlogId';

const POST_QUERY = gql`
  query BlogPage_GetPostByBlogId($input: GetPostBySubPostIdInput!) {
    getPostIdBySubPostId(input: $input) {
      result {
        _id
      }
    }
  }
`;

// TODO: this should be a next js middleware

export const BlogPage: React.FC = () => {
  const router = useRouter();
  const { blogId } = router.query;

  const { data, loading } = useQuery<
    BlogPage_GetPostByBlogId,
    BlogPage_GetPostByBlogIdVariables
  >(POST_QUERY, {
    variables: { input: { blogId: blogId.toString() } },
  });

  const postId = data?.getPostIdBySubPostId.result?._id;

  React.useEffect(() => {
    if (router.isReady) {
      if (postId) {
        router.replace({ pathname: `/community/post/${postId}`, query: router.query });
      }
    }
  }, [postId, router]);

  if (loading) {
    return <Loading />;
  }

  return null;
};
